<template>
  <b-modal :id="idModal" class="modal-info modal-has-close" hide-footer size="lg" scrollable centered>
    <template v-slot:modal-header>
      <div class="modal__head modal-info__head display-flex-center justify-content-between full-width">
        <h4 class="modal__title modal-info__title font-sanpro-bold primary-color-txt">{{ data.title }}</h4>
        <span @click="$bvModal.hide(idModal)" class="modal-info__close modal__close"><i class="icon-close"></i></span>
      </div>
    </template>
    <div class="modal__body modal-info__body primary-color-txt font-sanpro-light bg-color-light" v-html="data.content"></div>
  </b-modal>
</template>

<script>
  import { ID_MODAL_READ_LINK_TYPE } from './../../_store/constants'
  import { getReadMoreLinkTypes } from './../../_api/'
  import { mapActions } from 'vuex'

  export default {
    name: 'ModalReadMoreLinkType',
    data () {
      return {
        idModal: ID_MODAL_READ_LINK_TYPE,
        data: {}
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      ...mapActions('common', ['setLoading']),
      getData () {
        let self = this
        self.setLoading(true)
        getReadMoreLinkTypes().then(res => {
          if (res) {
            self.data = res;
          }
        }).catch().finally(() => self.setLoading(false))
      },
      // handleHideModal () {
      //   console.log('Hiden modal')
      // },
      // handleChangeModal () {
      //   console.log('Handle change modal');
      // }
    }
  }
</script>

<style lang="scss" scoped>
.modal-info {
  // &__head {
  //   padding: 20px 15px;
  // }

  // &__close {
  //   font-size: 7px;
  //   background: $color_err_question;
  //   @extend .border-rd-50;
  //   display: block;
  //   width: 15px;
  //   height: 15px;
  //   line-height: 15px;
  //   @extend .text-center;
  //   padding: 1px;
  //   position: absolute;
  //   top: 15px;
  //   right: 15px;
  //   cursor: pointer;

  //   .icon-close {
  //     @extend .color-light;
  //   }
  // }

  // &__body {
  //   padding: 15px;
  // }
}
</style>